<script setup lang="ts">
const { locale, availableLocales } = useI18n()
</script>

<template>
  <template
    v-for="availableLocale in availableLocales"
    :key="availableLocale"
  >
    <slot
      v-if="locale == availableLocale"
      :name="availableLocale"
    />
  </template>
</template>
